import React, { Component, Fragment } from "react";
import { withRouter } from 'react-router-dom';
import { ViewContainer } from "../../View.jsx";
import ViewUtils from '../../ViewUtils';
import Button from '@material-ui/core/Button';
import withMenuPermission from "../../widgets/withMenuPermission";
import { withStyles, makeStyles } from '@material-ui/core/styles';
import EnhancedToolbar from '../../widgets/Toolbar';
import AlertItem from "../../widgets/AlertItem";
import './Style.css'
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import EnhancedTable from '../../widgets/ResponsiveTable';
import LinkDialog from "../../etqa/LinkDialog";
import DGLetterReasonDialog from "../application/Controls/DGLetterReasonDialog";

const utils = new ViewUtils();

const toolbarConfig = {
    items: [
        {
            type: "buttonGroup",
            buttons: [
                { id: 'close', label: 'Back to DG Approval Dashboard', tooltip: '' }
            ]
        }
    ]
};

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: '#01579B',
        color: theme.palette.common.white,
        border: '1px solid white',
    },
    body: {
        fontSize: 11,
    },
}))(TableCell);

const StyledTableTextCell = withStyles((theme) => ({
    body: {
        fontSize: 14,
        fontWeight: 500
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
            height: theme.palette.action.main
        },
    },
}))(TableRow);

const headCells = [
    { id: 'Occupation', numeric: false, disablePadding: true, label: 'Occupation', widthRatio: .154 },
    { id: 'AfricanMale', numeric: false, disablePadding: true, label: 'African Male', widthRatio: .047 },
    { id: 'AfricanFemale', numeric: false, disablePadding: true, label: 'African Female', widthRatio: .047 },
    { id: 'AfricanDisabled', numeric: false, disablePadding: true, label: 'African Disabled', widthRatio: .047 },
    { id: 'ColouredMale', numeric: false, disablePadding: true, label: 'Coloured Male', widthRatio: .047 },
    { id: 'ColouredFemale', numeric: false, disablePadding: true, label: 'Coloured Female', widthRatio: .047 },
    { id: 'ColouredDisabled', numeric: false, disablePadding: true, label: 'Coloured Disabled', widthRatio: .047 },
    { id: 'IndianMale', numeric: false, disablePadding: true, label: 'Indian Male', widthRatio: .047 },
    { id: 'IndianFemale', numeric: false, disablePadding: true, label: 'Indian Female', widthRatio: .047 },
    { id: 'IndianDisabled', numeric: false, disablePadding: true, label: 'Indian Disabled', widthRatio: .047 },
    { id: 'WhiteMale', numeric: false, disablePadding: true, label: 'White Male', widthRatio: .047 },
    { id: 'WhiteFemale', numeric: false, disablePadding: true, label: 'White Female', widthRatio: .047 },
    { id: 'WhiteDisabled', numeric: false, disablePadding: true, label: 'White Disabled', widthRatio: .047 },
    { id: 'Age1', numeric: false, disablePadding: true, label: 'Age < 35', widthRatio: .047 },
    { id: 'Age2', numeric: false, disablePadding: true, label: 'Age 35 - 55', widthRatio: .047 },
    { id: 'Age3', numeric: false, disablePadding: true, label: 'Age > 55', widthRatio: .047 },
    { id: 'TotalMale', numeric: false, disablePadding: true, label: 'Total Male', widthRatio: .047 },
    { id: 'TotalFemale', numeric: false, disablePadding: true, label: 'Total Female', widthRatio: .047 },
    { id: 'TotalDisabled', numeric: false, disablePadding: true, label: 'Total Disabled', widthRatio: .047 }
];

const useStyles = theme => ({
    appBar: {
        position: 'relative',
    },
    title: {
        flex: 1,
        color: 'white',
    },
    table: {
        minWidth: 700,
    },
});

class DGApprovalMain extends Component {
    constructor(props) {
        super(props)
        this.state = {
            objectProps: (!utils.isNull(this.props.location.state) && !utils.isNull(this.props.location.state.object)) ? this.props.location.state.object : null,
            formObject: null,
            lookupADArray: [],
            lookupArray: [],
            FinancialYear: '',
            OrganisationName: '',
            Status: '',
            model: {
                Name: "",
            },
            title: "",
            id: (!utils.isNull(this.props.location.state) && !utils.isNull(this.props.location.state.DGApplicationID)) ? this.props.location.state.DGApplicationID : null,
            OrganisationID: (!utils.isNull(this.props.location.state) && !utils.isNull(this.props.location.state.OrganisationID)) ? this.props.location.state.OrganisationID : null,
            FinancialYearID: (!utils.isNull(this.props.location.state) && !utils.isNull(this.props.location.state.FinancialYearID)) ? this.props.location.state.FinancialYearID : null,
            FundingWindowID: (!utils.isNull(this.props.location.state) && !utils.isNull(this.props.location.state.FundingWindowID)) ? this.props.location.state.FundingWindowID : null,
            ApprovalPermission: "",
            searchParameters: [{ Name: "DGApplicationID", Value: this.props.location.state.DGApplicationID }, { Name: "OrganisationID", Value: this.props.location.state.OrganisationID }, { Name: "FinancialYearID", Value: this.props.location.state.FinancialYearID }],
            OpenDialog: false,
            formViewURL: "",
            formName: "",
            linkDialogOpen: false,
            linkDialogOpen2: false,
        };
    }

    componentDidMount() {
        this.getHeaders(this.state.id)
        this.getApproval(this.state.id)
        this.getApprovalStatusList(this.state.id)
        this.getlookup(this.state.id)
        this.CheckApprovalPermissions(this.state.id);
    }

    getHeaders = (id) => {
        let url = "api/sims/dgapproval/getfindheader?DGApplicationID=" + id;

        utils.invokeUrl(
            url,
            (response) => {
                this.setState({
                    FinancialYear: response.FinancialYear,
                    OrganisationName: response.OrganisationName,
                    SDLNumber: response.SDLNumber
                })
            },
            null,
            {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + localStorage.getItem("token"),
                },
            }
        );
    };

    getApproval(id) {
        let url = `api/sims/dgapproval/GetDGApproval?request={"searchParameters":[{"Name":"DGApplicationID","Value":${this.state.id}}]}`;
        utils.invokeUrl(url, (response) => {
            this.setState({
                formObject: response
            })
        },
            null,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + localStorage.getItem("token")
                }
            }
        )
    }

    getApprovalStatusList(id) {
        let url = `api/sims/dgapproval/GetDGApprovalStatusList?request={"searchParameters":[{"Name":"DGApplicationID","Value":${this.state.id}}]}`;
        utils.invokeUrl(url, (response) => {
            this.setState({
                ApprovalStatusListObject: response
            })
        },
            null,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + localStorage.getItem("token")
                }
            }
        )
    }

    getlookup(id) {
        let url = "api/sims/dgapproval/GetLookupListDGApprovalDetailStatus";
        utils.invokeUrl(url, (response) => {
            this.setState({ lookupADArray: response })
        },
            null,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + localStorage.getItem("token")
                }
            }
        )

        let urlV = "api/sims/dgapproval/GetLookupListDGApprovalStatus";
        utils.invokeUrl(urlV, (response) => {
            this.setState({ lookupVArray: response })
        },
            null,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + localStorage.getItem("token")
                }
            }
        )
    }

    CheckApprovalPermissions(id) {
        let url = "api/sims/DGApproval/GetDGApprovalPermissionCheck?DGApplicationID=" + this.state.id;
        utils.invokeUrl(url, (response) => {
            this.setState({
                ApprovalPermission: response.Result
            })
        },
            null,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + localStorage.getItem("token")
                }
            }
        )
    }




    handleChecklistArrayAD = (event, index) => {
        const values = [...this.state.formObject.DGApprovalInterventionDto.DGApprovalInterventionData];
        const indexObject = { ...values[index] };
        indexObject.DGApprovalDetailStatusID = event.target.value;
        values[index] = indexObject;
        const newDGApprovalInterventionDto = { ...this.state.formObject.DGApprovalInterventionDto };
        newDGApprovalInterventionDto.DGApprovalInterventionData = values;
        const finalObject = { ...this.state.formObject, DGApprovalInterventionDto: newDGApprovalInterventionDto }
        this.setState({ formObject: finalObject });
    }

    handleChecklistArrayNLA = (event, index) => {
        const values = [...this.state.formObject.DGApprovalInterventionDto.DGApprovalInterventionData];
        const indexObject = { ...values[index] };
        indexObject.NoOfLearnersApproved = event.target.value;
        values[index] = indexObject;
        const newDGApprovalInterventionDto = { ...this.state.formObject.DGApprovalInterventionDto };
        newDGApprovalInterventionDto.DGApprovalInterventionData = values;
        const finalObject = { ...this.state.formObject, DGApprovalInterventionDto: newDGApprovalInterventionDto }
        this.setState({ formObject: finalObject });
    }

    handleStatus = (event) => {
        const finalObject = { ...this.state.formObject, DGStatusID: { Id: event.target.value } }
        this.setState({ formObject: finalObject });
    }

    SaveApproval = () => {
        let url = "api/sims/dgapproval/UpdateDGApproval";
        utils.invokeUrl(url, (response) => {
            this.successCallback(response);
        },
            (response) => {
                this.error(response);
            },
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + localStorage.getItem("token")
                },
                body: JSON.stringify(this.state.formObject)
            }
        )
    }

    ReverseDGApproval = () => {
        let url = "api/sims/dgapproval/ReverseDGApproval";
        utils.invokeUrl(url, (response) => {
            this.successCallback(response);
        },
            (response) => {
                this.error(response);
            },
            {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + localStorage.getItem("token")
                },
                body: JSON.stringify(({
                    "DGApplicationID": this.state.id
                }))
            }
        )
    }

    CheckStatus = () => {
        let IntDataHasRejection = 0;
        if (!utils.isNull(this.state.formObject.DGApprovalInterventionDto.DGApprovalInterventionData)) {
            let IntData = this.state.formObject.DGApprovalInterventionDto.DGApprovalInterventionData;
            for (let i = 0; i < IntData.length; i++) {
                if (IntData[i].DGApprovalDetailStatusID === 2 || IntData[i].DGApprovalDetailStatusID === "2") { IntDataHasRejection = 1; }
            }
        }
        if (this.state.formObject.DGStatusID.Id === "5" || this.state.formObject.DGStatusID.Id === 5 || IntDataHasRejection === 1) {
            this.setState({
                linkDialogOpen: true,
                linkDialogTitle: 'Rejection Reasons',
                LinkDialogName: 'RejectionReasons',
                NewDGStatusID: 5,
                message: ""
            })
        }
        else { this.EmailDGLetter(null) }

    }

    ViewRejLetterCheckStatus = () => {
        let IntDataHasRejection = 0;
        if (!utils.isNull(this.state.formObject.DGApprovalInterventionDto.DGApprovalInterventionData)) {
            let IntData = this.state.formObject.DGApprovalInterventionDto.DGApprovalInterventionData;
            for (let i = 0; i < IntData.length; i++) {
                if (IntData[i].DGApprovalDetailStatusID === 2 || IntData[i].DGApprovalDetailStatusID === "2") { IntDataHasRejection = 1; }
            }
        }
        if (this.state.formObject.DGStatusID.Id === "5" || this.state.formObject.DGStatusID.Id === 5 || IntDataHasRejection === 1) {
            this.setState({
                linkDialogOpen2: true,
                linkDialogTitle: 'Rejection Reasons',
                LinkDialogName: 'RejectionReasons',
                NewDGStatusID: 5,
                message: ""
            })
        }
        else { this.DownloadDGRejectionLetter(null) }

    }

    EmailDGLetter = (selection) => {
        let ReasonsList = "";
        if (selection !== null) {
            for (let i = 0; i < selection.length; i++) {
                if (i === 0) { ReasonsList += selection[i].Id; }
                else { ReasonsList += "," + selection[i].Id; }

            }
        }

        let SaveObject = { ...this.state.formObject, Reasons: ReasonsList };
        this.setState({ formObject: SaveObject });

        let url = "api/sims/dgapproval/EmailDGLetter";
        utils.invokeUrl(url, (response) => {
            this.successCallback(response);
        },
            (response) => {
                this.error(response);
            },
            {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + localStorage.getItem("token")
                },
                body: JSON.stringify(SaveObject)
            }
        )
    }

    postLinkHandler(isCancel, linked) {
        if (linked === true) {

            this.setState({
                linkDialogOpen: false,
                linkDialogOpen2: false,
                searchParameters: JSON.parse(JSON.stringify(this.state.searchParameters))
            });
        }
        else if (isCancel === true) {
            this.setState({
                linkDialogOpen: false,
                linkDialogOpen2: false
            })
        }
    }

    successCallback(response) {

        if (response.MessageType === "WARNING") {
            let errResult = JSON.parse(response.Message);
            let message = "";
            errResult.map((item, index) => (
                message += item.Item1 + ' : ' + item.Item2 + '\n'
            ))
            this.setState({ message: message, messageStyle: response.MessageType });
        }
        else {
            this.setState({ message: response.Message, messageStyle: response.MessageType });
            this.getApproval(this.state.id);
            this.getApprovalStatusList(this.state.id)
        }
    }
    error(response) {
        this.setState({ message: response.Message, messageStyle: response.MessageType });
    }

    close() {
        this.props.history.push({
            pathname: '/DGApprovalSearch',
            state: {
                organisationID: this.state.OrganisationID,
                DGApplicationID: this.state.id,
                FinancialYearID: this.state.FinancialYearID,
                organisationName: this.state.OrganisationName,
                sdlnumber: this.state.SDLNumber
            },
        });
    }

    handleToolbarButtonClick(buttonId) {
        if ("close" === buttonId) {
            this.close();
        }
    }

    buttonSubmitClickHandler() {
        this.submit();
    }

    DownloadDGApprovalLetter = () => {
        let url = "api/sims/dgapproval/DownloadDGApprovalLetter";
        utils.invokeUrl(url, (response) => {
            if (!utils.isNull(response.MessageType) && response.MessageType === "ERROR") {
                this.setState({ message: response.Message, messageStyle: response.MessageType });
            }
            else {
                var blob = new Blob([this.base64ToArrayBuffer(response.Base64)], { type: response.Type });
                var url = URL.createObjectURL(blob);

                const link = document.createElement('a');
                link.href = url;
                link.download = response.Name;
                link.target = '_blank';
                link.click();
            }
        }, (e) => {
            this.setState({ messsageAlert: utils.SYSTEM_ERROR_MESSAGE, messageStyle: "outlinedError" });
        },
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + localStorage.getItem("token")
                },
                body: JSON.stringify(this.state.formObject)
            }
        );
    };

    DownloadDGRejectionLetter = (selection) => {

        let ReasonsList = "";
        if (selection !== null) {
            for (let i = 0; i < selection.length; i++) {
                if (i === 0) { ReasonsList += selection[i].Id; }
                else { ReasonsList += "," + selection[i].Id; }

            }
        }

        let SaveObject = { ...this.state.formObject, Reasons: ReasonsList };
        this.setState({ formObject: SaveObject });

        let url = "api/sims/dgapproval/DownloadDGRejectionLetter";
        utils.invokeUrl(url, (response) => {
            if (!utils.isNull(response.MessageType) && response.MessageType === "ERROR") {
                this.setState({ message: response.Message, messageStyle: response.MessageType });
            }
            else {
                var blob = new Blob([this.base64ToArrayBuffer(response.Base64)], { type: response.Type });
                var url = URL.createObjectURL(blob);

                const link = document.createElement('a');
                link.href = url;
                link.download = response.Name;
                link.target = '_blank';
                link.click();
            }
        }, (e) => {
            this.setState({ messsageAlert: utils.SYSTEM_ERROR_MESSAGE, messageStyle: "outlinedError" });
        },
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + localStorage.getItem("token")
                },
                body: JSON.stringify(SaveObject)
            }
        );
    };

    base64ToArrayBuffer(base64) {
        var binary_string = window.atob(base64);
        var len = binary_string.length;
        var bytes = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
            bytes[i] = binary_string.charCodeAt(i);
        }
        return bytes.buffer;
    };

    render() {

        const { classes } = this.props;

        const inttableheader = !utils.isNull(this.state.formObject) ? this.state.formObject.DGApprovalInterventionDto.FriendlyColumnNames.map((item, index) => (
            item === "ID" ? <StyledTableCell align="left">#</StyledTableCell> : <StyledTableCell>{item}</StyledTableCell>
        )) : null;

        const inttablerows = !utils.isNull(this.state.formObject) ? this.state.formObject.DGApprovalInterventionDto.DGApprovalInterventionData.map((item, index) => (
            <StyledTableRow key={item.ID}>
                {Object.keys(item).map((innerItem, indexObject) => (
                    indexObject === 0 ? <StyledTableCell component="th" scope="row">
                        {indexObject + 1}
                    </StyledTableCell> :
                        innerItem === "DGApprovalDetailStatusID" ?
                            <StyledTableCell align="left" component="th" scope="row" >
                                <TextField className="w-30" id={"DGApprovalDetailStatusID" + item.ID} value={item.DGApprovalDetailStatusID} select margin="normal" size="small" variant="outlined" style={{ minWidth: "200px", width: "100% !important" }} onChange={(values) => this.handleChecklistArrayAD(values, index)} >
                                    <MenuItem value={0} key={0} >  </MenuItem>
                                    {this.state.lookupADArray.map((lookupitem, index) => (
                                        <MenuItem value={lookupitem.Id} key={lookupitem.Id} >{lookupitem.Description}</MenuItem>
                                    ))}
                                </TextField>
                            </StyledTableCell> :
                            innerItem === "NoOfLearnersApproved" ?
                                <StyledTableCell align="center" component="th" scope="row" >
                                    <TextField id={"NoOfLearnersApproved" + item.Number} type="number" inputProps={{ min: 0 }} value={item.NoOfLearnersApproved} variant="outlined" style={{ minWidth: "300px", width: "100% !important" }} onChange={(values) => this.handleChecklistArrayNLA(values, index)}> </TextField>
                                </StyledTableCell> :
                                <StyledTableCell align="left">{item[innerItem]}</StyledTableCell>
                ))}
            </StyledTableRow >
        ))
            :
            null;

        const statuslistrows = !utils.isNull(this.state.ApprovalStatusListObject) && this.state.ApprovalStatusListObject.TotalNumberOfRows !== 0 ? this.state.ApprovalStatusListObject.Data.map((item, index) => (

            <StyledTableRow key={item.ID}>
                <StyledTableCell align="left">{item.Approver}</StyledTableCell>
                <StyledTableCell align="left">{item.ApprovalDate}</StyledTableCell>
                <StyledTableCell align="left">{item.DGStatus}</StyledTableCell>
            </StyledTableRow >
        ))
            :
            null;

        return (
            <ViewContainer topPadding="0" title="">
                <AlertItem message={this.state.message} alertStyle={this.state.messageStyle} />
                <br />
                <table width="100%" class="FormsTableHeader">
                    <tbody>
                        <tr>
                            <td>
                                <EnhancedToolbar highlight={false} title="" buttonClickHandler={(buttonId) => this.handleToolbarButtonClick(buttonId)} enabled={true} config={toolbarConfig} />
                            </td>
                            <td align="center">
                                <b>DG Approval</b><br />
                                <b>{this.state.FinancialYear}</b>
                            </td>
                            <td align="right">
                                <b>{this.state.OrganisationName} - {this.state.SDLNumber}</b>&nbsp;&nbsp;&nbsp;
                            </td>
                        </tr>
                    </tbody>
                </table>
                <br />
                <br />
                <Table className={classes.table} size="small" >
                    <TableHead>
                        <TableRow>
                            {inttableheader}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {inttablerows}
                    </TableBody>
                </Table>
                <br />
                <br />
                <TableContainer component={Paper}>
                    <table className={classes.table} aria-label="simple table" size="small">
                        <tbody>
                            <TableRow>
                                <td align="left">
                                    <b>Status</b><br />
                                </td>
                                <td align="left">
                                    <TextField className="w-30" id="DGStatusID" value={!utils.isNull(this.state.formObject) && !utils.isNull(this.state.formObject.DGStatusID) ? this.state.formObject.DGStatusID.Id : 0} select margin="normal" size="small" variant="outlined" style={{ minWidth: "200px", width: "100% !important" }}
                                        onChange={(values) => this.handleStatus(values)}>
                                        <MenuItem value={0} key={0} >  </MenuItem>
                                        {!utils.isNull(this.state.lookupVArray) ? this.state.lookupVArray.map((lookupVitem, index) => (

                                            <MenuItem value={lookupVitem.Id} key={lookupVitem.Id} >{lookupVitem.Description}</MenuItem>

                                        )) : null}
                                    </TextField>
                                </td>
                            </TableRow>
                            <TableRow>
                                <td align="left">
                                    <b>Approved/Not Approved By</b><br />
                                </td>
                                <td align="left">

                                    <TextField id="Evaluator" disabled={true} value={!utils.isNull(this.state.formObject) ? this.state.formObject.ApprovedBy : ""} variant="outlined" margin="dense" style={{ minWidth: "300px", width: "100% !important" }} > </TextField>
                                </td>
                            </TableRow>
                            <TableRow>
                                <td align="left">
                                    <b>Approved/Not Approved Date</b><br />
                                </td>
                                <td align="left">

                                    <TextField id="DateEvaluated" disabled={true} value={!utils.isNull(this.state.formObject) ? this.state.formObject.ApprovedDate : ""} variant="outlined" margin="dense" style={{ minWidth: "300px", width: "100% !important" }} > </TextField>
                                </td>
                            </TableRow>
                        </tbody>
                    </table>
                </TableContainer>
                {!utils.isNull(this.state.ApprovalStatusListObject) && this.state.ApprovalStatusListObject.TotalNumberOfRows !== 0 ?
                    <Fragment>
                        <br />
                        <br />
                        <Table className={classes.table} size="small" >
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell>Updated By</StyledTableCell>
                                    <StyledTableCell>Date Updated</StyledTableCell>
                                    <StyledTableCell>DG Status</StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {statuslistrows}
                            </TableBody>
                        </Table>
                    </Fragment>
                    : null}
                <br />
                <Fragment>
                    <Button variant="outlined" size="small" id="btnSave" color="#01579B" disabled={this.state.ApprovalPermission === "ViewOnly" || (!utils.isNull(this.state.formObject) && this.state.formObject.IsLetterGenerated === 1) ? true : false} onClick={this.SaveApproval}>Save</Button>&nbsp;
                    <Button variant="outlined" size="small" id="btnDownloadLetter" color="#01579B" disabled={!utils.isNull(this.state.formObject) && (this.state.formObject.HasApproval) === 0 ? true : false} onClick={this.DownloadDGApprovalLetter}>View Approval Letter</Button>&nbsp;
                    <Button variant="outlined" size="small" id="btnDownloadLetterR" color="#01579B" disabled={!utils.isNull(this.state.formObject) && (this.state.formObject.HasRejection) === 0 ? true : false} onClick={this.ViewRejLetterCheckStatus}>View Rejection Letter</Button>&nbsp;
                    {!utils.isNull(this.state.formObject) && this.state.formObject.ShowLetterButton === 1 ?
                        <Fragment>
                            <Button variant="outlined" size="small" id="btnEmailLetter" color="#01579B" disabled={!utils.isNull(this.state.formObject) && this.state.formObject.DisableLetterButton === 1 ? true : false} onClick={this.CheckStatus}>Generate Email Notification to the Stakeholder</Button>&nbsp;
                        </Fragment>
                        : null
                    }
                    <Button variant="outlined" size="small" id="btnReverse" color="#01579B" disabled={!utils.isNull(this.state.formObject) && this.state.formObject.CanReverse === 0 ? true : false} onClick={this.ReverseDGApproval}>Reverse Approval/Letter Generation</Button>&nbsp;
                </Fragment>

                <LinkDialog open={this.state.linkDialogOpen} type={this.state.selectedLinkType}
                    title={this.state.linkDialogTitle}
                    closeHandler={(isCancelled, linked) => this.postLinkHandler(isCancelled, linked)}
                    dialogTitle={this.state.linkDialogTitle}
                    linkName={this.state.linkDialogName} linkHandler={(selection) => this.EmailDGLetter(selection)}
                    selectionId={this.state.id}
                    buttonName="Save"
                >
                    <DGLetterReasonDialog
                        dataUrl={"api/sims/dgapproval/GetDGLetterReasons"}
                        multiSelect={true} showTitle={false}
                        DGApplicationID={this.state.id}
                        NewDGStatusID={this.state.NewDGStatusID}
                        mode="lookup"
                    />
                </LinkDialog>

                <LinkDialog open={this.state.linkDialogOpen2} type={this.state.selectedLinkType}
                    title={this.state.linkDialogTitle}
                    closeHandler={(isCancelled, linked) => this.postLinkHandler(isCancelled, linked)}
                    dialogTitle={this.state.linkDialogTitle}
                    linkName={this.state.linkDialogName} linkHandler={(selection) => this.DownloadDGRejectionLetter(selection)}
                    selectionId={this.state.id}
                    buttonName="Save"
                >
                    <DGLetterReasonDialog
                        dataUrl={"api/sims/dgapproval/GetDGLetterReasons"}
                        multiSelect={true} showTitle={false}
                        DGApplicationID={this.state.id}
                        NewDGStatusID={this.state.NewDGStatusID}
                        mode="lookup"
                    />
                </LinkDialog>
            </ViewContainer>

        );
    }
}

export default withRouter(withStyles(useStyles())(withMenuPermission(DGApprovalMain)));